import reducer from './reducers';

export { default as walletsOperations } from './operations';
export { default as walletsTypes } from './types';

export default reducer;
